module.exports = __webpack_public_path__ + "static/media/marker-blue.bb86e6b0.svg";